import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './index.css';

import App from './App';
import { AuthProvider } from './components/auth/AuthContext';
import { AppConfig, getAppConfig } from './utils/appConfig';
import { initializeAwsTracking } from './utils/awsTracking';

const config: AppConfig = getAppConfig();
const appName = config.ENV.toUpperCase() === 'PROD' ?
  'Proprio Data Admin Portal' :
  `Proprio Data Admin Portal (${config.ENV})`;

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

// Initialize tracking services
initializeAwsTracking(config);

createRoot(rootElement).render(
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App appName={appName} />
      </BrowserRouter>
    </AuthProvider>
  </StrictMode>
);

